import {alpha, Box, Chip, Tab, Tooltip} from "@mui/material";
import Tabs, {tabsClasses} from "@mui/material/Tabs";
import React from "react";


export default function ChipsTab({labels, selected, onChange, maxWidth}) {

    const handleChange = (event, newValue) => {
        onChange(newValue);
    }

    return (
        <Box sx={{
            bgcolor: 'background.paper',
            borderRadius: "0.2em",
            width: maxWidth,
        }}>
            <Tabs
                value={false}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons
                aria-label="labels chips"
                sx={{
                    [`& .${tabsClasses.scrollButtons}`]: {
                        '&.Mui-disabled': {opacity: 0.3},
                    },
                }}
            >
                {Array.isArray(labels) && labels.map((label) => (
                    <Tab
                        key={`chip-tab-${label.id}`}
                        value={label.id}
                        sx={{
                            "&.MuiTab-root": {
                                p: 1,
                                minWidth: "fit-content",
                            },
                        }}
                        disableRipple
                        label={
                            <Tooltip title={label.description ? label.description : ""}>
                                <Chip
                                    size="small"
                                    sx={{
                                        "&.MuiChip-root": {
                                            color: theme => selected.includes(label.id)
                                                ? theme.palette.getContrastText(label.color)
                                                : theme.palette.text.primary,
                                            bgcolor: label.color
                                                ? selected.includes(label.id) ? label.color : "default"
                                                : "default",
                                            ":hover": {
                                                bgcolor: label.color
                                                    ? selected.includes(label.id) ? alpha(label.color, 0.6) : "default"
                                                    : "default",
                                                borderRadius: "1em"
                                            }
                                        }
                                    }}
                                    label={label.label}
                                />
                            </Tooltip>
                        }
                    />
                ))}
            </Tabs>
        </Box>
    );
}

ChipsTab.defaultProps = {
    labels: [],
    selected: [],
    onChange: () => {
    },
    maxWidth: "75vw"
}